import { render, staticRenderFns } from "./PrintCol.vue?vue&type=template&id=e8b4a980&"
import script from "./PrintCol.vue?vue&type=script&lang=js&"
export * from "./PrintCol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.1_qqg2mlm7tcp4cjng2lo6klgciy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports